/** combinedViewer.ts */
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { Mesh, Material, Object3DEventMap, SphereGeometry } from 'three';
import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry';
import { isVisibleDesignSpaceState } from 'features/three-view/state/threeAtoms';
import { createConvexMesh } from '../utils/geometry';
import { convexMaterial } from '../utils/materials';
import { useDesignSpaceViewerData } from '../hooks/useDesignSpaceViewerData';

export const DesignSpaceViewer: React.FC = () => {
  const isVisibleDesignSpace = useRecoilValue(isVisibleDesignSpaceState);
  const { scene, drawable, coordinates } = useDesignSpaceViewerData();

  useEffect(() => {
    if (!drawable || !isVisibleDesignSpace) return;

    // Arrays to hold meshes for cleanup
    let meshes: Mesh<ConvexGeometry | SphereGeometry, Material, Object3DEventMap>[] = [];

    // Create convex meshes
    const fullConvexMesh = createConvexMesh(coordinates, convexMaterial);
    if (fullConvexMesh) {
      fullConvexMesh.renderOrder = 0;
      scene.add(fullConvexMesh);
      meshes.push(fullConvexMesh);
    }

    // Cleanup function to remove and dispose of meshes
    return () => {
      meshes.forEach(mesh => {
        scene.remove(mesh);
        mesh.geometry.dispose();
        mesh.material.dispose();
      });
    };
  }, [
    isVisibleDesignSpace,
    coordinates,
    scene,
    drawable,
  ]);

  return null;
};
